import $ from "jquery";

import "../../components/desktop/setup";
import "../../components/desktop/booking";
import { initPostBookingTracking, initAncillaryAjaxTracking } from "../../app/helpers/classes/post_booking_tracking";

initPostBookingTracking();
// Desktop loads rails-ujs from webpack, so it fires on this same jQuery.
initAncillaryAjaxTracking($);

$(function () {
  $(".fancybox").fancybox();

  // open booking modal
  // document.getElementById("hidden_hotel_link").click();

  $('#baggage-form').on('submit', function(e) {
    var checkboxes = $('#baggage-form input[type="checkbox"]:checked').length;

    if(checkboxes < 1){
      alert(checkboxes);
      e.preventDefault();
      return false;
    }
    return true;
  });
});
